$ = require('jquery')
require("bootstrap-daterangepicker")
moment = require("moment")

GroupEventEditCtrl = ($scope ,$filter ,$location ,flash ,formDialogService ,formFileReaderService ,detailData ,groupRegisDataService ,groupEventService ,$ngConfirm ) ->
  # check invalid groupEventInfo
  groupEventInfo = detailData.eventDetail
  if groupEventInfo is undefined || groupEventInfo.id is undefined
    return $location.path('/groups')

  angular.element(document.body).css 'min-width', 0
  $scope.eventInfo =
    group_id : groupEventInfo.group_id
    id: groupEventInfo.id
    start_date : moment(groupEventInfo.start_date).format("'YYYY-MM-DD'T'HH:mm:ssZ'")
    end_date : moment(groupEventInfo.end_date).format("'YYYY-MM-DD'T'HH:mm:ssZ'")
    name : groupEventInfo.name
    location : groupEventInfo.location
    description : groupEventInfo.description

  $scope.croppedCoverPhoto = groupEventInfo.cover_url
  $scope.groupEventInfo = groupEventInfo

  defDirS3 =
    prefixCover: 'images/group/event'
  maxFileUploadSize = 5000000
  configDatePicker =
    singleDatePicker: true
    showDropdowns: true
    locale:
      format: "YYYY/MM/DD"

  $scope.isSubmitting = false
  # cover url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then (resp) ->
    $scope.preDataCover = resp.data

  $(document).ready () ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
    $('#txtStartDate').daterangepicker configDatePicker , (start, end) ->
      checkValidDate()
    $('#txtEndDate').daterangepicker configDatePicker , (start, end) ->
      checkValidDate()


  $scope.chooseCover = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('coverPhoto', file).then (data) ->
        $scope.coverData = data
        $scope.coverPhoto = data.base64Data
        $('.crop-image-modal').modal 'show'
    )

  $scope.cancelCropModal = ->
    $scope.coverPhoto = ''
    $('#coverPhoto').attr('src', '')
    $scope.croppedCoverPhoto = $scope.groupEventInfo.cover_url
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submitCropModal = ->
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submit = (eventInfo) ->
    $scope.isSubmitting = true

    coverFile = if $scope.coverPhoto?
      $scope.croppedCoverPhotoBlob
    else
      $scope.croppedCoverPhoto

    coverData = {
      coverFile: coverFile
      url: $scope.preDataCover.url
      fields: $scope.preDataCover.fields
    }
    groupEventService.updateEvent(eventInfo ,coverData )
      .then (data) ->
        if data == 'success'
          flash.success data
          $scope.isSubmitting = false
          $scope.gotoEventTab()
      , (data) ->
        if data?.data.code is 'error.name_already_taken'
          flash.error $filter('translate')('NAME_DUPLICATED')
        else
          flash.error $filter('translate')('API_ERROR')
        $scope.isSubmitting = false

  $scope.buttonCancelClick = ->
    $scope.gotoEventTab()

  $scope.gotoEventTab = ->
    url = "/group-event/"+ groupEventInfo.id + "/ranking"
    $location.url(url)

  $scope.deleteEvent = ->
    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS')
    errorMess = $filter('translate')('_GROUP_EVENT.CANCEL')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: ->
            groupEventService.deleteEvent(groupEventInfo.id)
              .then (resp) ->
                url_rank = "/groups/"+ groupEventInfo.group_id + "#rank"
                $location.url(url_rank)
              .catch (resp) ->
                $ngConfirm(errorMess)
    $ngConfirm(config)

  #valid date start end date
  checkValidDate = ->
    startData = $('#txtStartDate').data('daterangepicker')
    endData   = $('#txtEndDate').data('daterangepicker')
    if startData is undefined || endData is undefined
      return
    if startData.startDate > endData.startDate
      $scope.eventForm.endDate.$setValidity 'dateValid', false
    else
      $scope.eventForm.endDate.$setValidity 'dateValid', true

  isNotValidSizeFile = (file) ->
    file.size > maxFileUploadSize

  openFileDialog = (callback) ->
    options = {
      accept : 'image/*'
    }
    formDialogService._open(options , (file,fileLocation) ->
      if isNotValidSizeFile(file)
        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes')
        return
      callback(file,fileLocation)
    )

GroupEventEditCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  'flash'
  'formDialogService'
  'formFileReaderService'
  'detailData'
  'groupRegisDataService'
  'groupEventService'
  '$ngConfirm'
]

module.exports = GroupEventEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-edit-controller.coffee